import { fonts } from "assets/fonts";
import { Button, Col, Row } from "components/primitives";
import { DashboardContext } from "contexts/DashboardContext";
import { FC, useContext } from "react";
import styled from "styled-components";
import { DashboardProps } from "types/GlobalData";

import { SegmentProps } from "./ToolbarContainer";
import { ToolbarSegmentHeader } from "./ToolbarSegmentHeader";

export const FontsToolbar: FC<SegmentProps> = ({ setCurrentSegment, data, onSetData }) => {
  const { data: globalData, setData: updateGlobalData } = useContext(DashboardContext);

  const handleChangeFont = (value: string) => {
    const newData = globalData.dashboardGroups
      .find((group) => group.id === globalData.activeDashboardGroupId)!
      .dashboards.map((dashboard) => {
        if (dashboard.id === globalData.activeDashboardId) {
          return {
            ...dashboard,
            fontName: value,
          };
        }

        return dashboard;
      });

    const newDashboardGroups = getUpdatedDashboardGroups(newData);

    updateGlobalData({
      dashboardGroups: newDashboardGroups,
    });
    onSetData({
      ...data,
      fontName: value,
    });
  };

  const getUpdatedDashboardGroups = (updatedDashboardData: DashboardProps[]) => {
    return globalData.dashboardGroups.map((group) =>
      group.id === globalData.activeDashboardGroupId
        ? { ...group, dashboards: updatedDashboardData }
        : group,
    );
  };

  const handleBack = () => {
    setCurrentSegment("settings");
  };

  return (
    <OuterContainer>
      <ToolbarSegmentHeader header="Fonts" onBack={handleBack} />
      <InnerContainer>
        {Object.keys(fonts).map((key) => {
          const handleClick = () => handleChangeFont(key);

          return (
            <SettingButton
              key={key}
              highlighted={key === data.fontName}
              fontFamily={fonts[key]}
              onClick={handleClick}
            >
              <SettingFont fontFamily={fonts[key]}>Abc</SettingFont>
              {key}
            </SettingButton>
          );
        })}
      </InnerContainer>
    </OuterContainer>
  );
};

const OuterContainer = styled(Col)`
  height: 100%;
  overflow: auto;
`;

const InnerContainer = styled(Row)`
  gap: 10px;
  flex-wrap: wrap;
  padding: 5px;
`;

const SettingButton = styled(Button)<{ fontFamily: string }>`
  display: flex;
  flex-direction: column;
  width: 47%;
  aspect-ratio: 0.85;
  justify-content: space-around;
  align-items: center;
  padding: 10px 10px;
  box-shadow: 0 0 5px rgba(0, 9, 43, 0.5);
  border-radius: 8px;
  border: none;
  font-family: ${({ fontFamily }) => fontFamily};
`;

const SettingFont = styled.div<{ fontFamily: string }>`
  font-family: ${({ fontFamily }) => fontFamily};
  width: 100%;
  border: 1px solid black;
  border-radius: 3px;
  padding: 8px;
  font-size: 20px;
`;
